import React, { useState } from "react";
import useFetchVesselInformation from "../Utils/useFetchVesselInformation";
import { ToastContainer, toast } from "react-toastify";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import Skeleton from "react-loading-skeleton";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";


const VesselInformation = ({ vesselId }) => {
  const { data, isLoading, isError, error } = useFetchVesselInformation(vesselId);
  const [collapsedSections, setCollapsedSections] = useState({
    vesselinformation: true,
  });

  const toggleSection = (section) => {
    setCollapsedSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  if (isError) {
    toast.error(error.message || "An error occurred while fetching the vessel primary information.");
    return <div>Error: {error.message}</div>;
  }

  const {
    available,
    live,
    stockedQuantity,
    soldQuantity,
    vesselInformation,
  } = data?.data || {};

  return (
    <div className="myvessel-details-container">
      <div className="info" onClick={() => toggleSection("vesselinformation")}>
        <p>Vessel Information</p>
        {collapsedSections.vesselinformation ? <IoIosArrowDown /> : <IoIosArrowUp />}
      </div>
      {!collapsedSections.vesselinformation && (
        <div className="card">
          <p>
            <strong>Beam Moulded</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.beamMoulded || "Not Provided"}
          </p>
          <p>
            <strong>BHP</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.bhp || "Not Provided"}
          </p>
          <p>
            <strong>Bollard Pull</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.bollardPull || "Not Provided"}
          </p>
          <p>
            <strong>Builder</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.builder || "Not Provided"}
          </p>
          <p>
            <strong>Call Sign</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.callSign || "Not Provided"}
          </p>
          <p>
            <strong>Classification</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.classification || "Not Provided"}
          </p>
          <p>
            <strong>Crusing Speed</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.cruisingSpeed || "Not Provided"}
          </p>
          <p>
            <strong>Deck Space</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.deckSpace || "Not Provided"}
          </p>
          <p>
            <strong>Deck Strength</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.deckStrength || "Not Provided"}
          </p>
          <p>
            <strong>Draft</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.draft || "Not Provided"}
          </p>
          <p>
            <strong>Fuel Capacity</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.fuelCapacity || "Not Provided"}
          </p>
          <p>
            <strong>Generators</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.generators || "Not Provided"}
          </p>
          <p>
            <strong>Gross Tonnage</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.grossTonnage || "Not Provided"}
          </p>
          <p>
            <strong>IMO Number</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.imoNumber || "Not Provided"}
          </p>
          <p>
            <strong>Keel Laid</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.keelLaid || "Not Provided"}
          </p>
          <p>
            <strong>Length Overall</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.lengthOverall || "Not Provided"}
          </p>
          <p>
            <strong>MMSI Number</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.mmsiNumber || "Not Provided"}
          </p>
          <p>
            <strong>Number of Berths</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.numberOfBerths || "Not Provided"}
          </p>
          <p>
            <strong>Official Number</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.officialNumber || "Not Provided"}
          </p>
          <p>
            <strong>Port of Registry</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.portOfRegistry || "Not Provided"}
          </p>
          <p>
            <strong>Propulsion</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.propulsion || "Not Provided"}
          </p>
          <p>
            <strong>Range</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.range || "Not Provided"}
          </p>
          <p>
            <strong>Speed</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.speed || "Not Provided"}
          </p>
          <p>
            <strong>Water Capacity</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.waterCapacity || "Not Provided"}
          </p>
          <p>
            <strong>Year of Built</strong> {isLoading ? <Skeleton width={150} /> : vesselInformation?.yearOfBuilt || "Not Provided"}
          </p>
          <p>
            <strong>Stocked Quantity</strong> {isLoading ? <Skeleton width={150} /> : stockedQuantity || "Not Provided"}
          </p>
          <p>
            <strong>Sold Quantity</strong> {isLoading ? <Skeleton width={150} /> : soldQuantity || "Not Provided"}
          </p>
          <p>
            <strong>Available</strong> {isLoading ? <Skeleton width={150} /> : available ? "Yes" : "No"}
          </p>
          <p>
            <strong>Live</strong> {isLoading ? <Skeleton width={150} /> : live ? "Yes" : "No"}
          </p>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default VesselInformation;
